export const getLoginErrorCode = state => state.loginState.errorCode;
export const getLoginProcessing = state => state.loginState.loginProcessing;
export const getLoginComplete = state => state.loginState.loginComplete;
